import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { inject, NgModule } from '@angular/core'
import { InMemoryCache } from '@apollo/client/core'
import { provideApollo as provideDefaultApollo, provideNamedApollo } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import { environment } from './environments/environment'

@NgModule({
  providers: [
    provideDefaultApollo(() => {
      const httpLink = inject(HttpLink)
      return {
        cache: new InMemoryCache(),
        name: 'sammathnaur',
        link: httpLink.create({
          uri: environment.SAMMATHNAUR_BASE_URL,
        }),
        defaultOptions: {
          query: {
            fetchPolicy: 'network-only',
          },
        },
      }
    }),
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink)
      return {
        mordu: {
          name: 'mordu',
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.MORDU_BASE_URL,
          }),
        },
      }
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class GraphqlModule {}
